import React from "react";
const TmsPosPerformanceScan = () => {
  return <div>Performance Scan</div>;
};
export default TmsPosPerformanceScan;
